import { supabase } from '../supabaseClient';
import { sendEmail, safetyIncidentEmail } from './email';

// Escalate a reportable safety incident IMMEDIATELY (brief §4): email every
// internal user who opted into safety-incident alerts (the split preference,
// safety_incident_emails). Best-effort — the incident row and feedback are
// already saved, so a mail hiccup must not roll them back. Mirrors the
// compliance-alert fan-out.
export async function escalateSafetyIncident({ supplierId, supplierName, briefId, briefName, projectNumber, note, raisedByUserId }) {
  if (!supplierId) return;

  let raisedByName = '';
  if (raisedByUserId) {
    const { data } = await supabase.from('internal_users').select('full_name').eq('id', raisedByUserId).maybeSingle();
    raisedByName = data?.full_name || '';
  }

  const { data: recipients } = await supabase
    .from('internal_users')
    .select('id, full_name, email, is_active, safety_incident_emails')
    .eq('safety_incident_emails', true);
  const eligible = (recipients || []).filter(r => r.email && r.is_active !== false);
  if (eligible.length === 0) return;

  const supplierUrl = `${window.location.origin}/suppliers/${supplierId}`;
  const sentTo = [];
  for (const r of eligible) {
    const { subject, html } = safetyIncidentEmail({
      recipientName: r.full_name,
      supplierName,
      briefName,
      projectNumber,
      note,
      raisedByName,
      supplierUrl,
    });
    try {
      await sendEmail({ to: r.email, subject, html });
      sentTo.push(r.email);
    } catch { /* per-recipient failure shouldn't stop the fan-out */ }
  }

  if (sentTo.length > 0) {
    await supabase.from('supplier_email_log').insert([{
      supplier_id: supplierId,
      email_kind: 'safety_incident_alert',
      recipients: sentTo,
      sent_by: raisedByUserId || null,
    }]);
  }
}
